import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { WISHLIST_REMOVE_ENTRY } from '../wishlist-state';

export const REMOVE_WISHLIST_ENTRY = '[Wishlist] Remove Wishlist Entry';
export const REMOVE_WISHLIST_ENTRY_SUCCESS = '[Wishlist] Remove Wishlist Entry Success';
export const REMOVE_WISHLIST_ENTRY_FAIL = '[MyAccount] Remove Wishlist Entry Fail';

export class RemoveWishlistEntry extends StateUtils.EntityLoadAction {
  readonly type = REMOVE_WISHLIST_ENTRY;

  constructor(public payload: WishlistEntry) {
    super(WISHLIST_REMOVE_ENTRY, payload.productCode);
  }
}

export class RemoveWishlistEntrySuccess extends StateUtils.EntitySuccessAction {
  readonly type = REMOVE_WISHLIST_ENTRY_SUCCESS;

  constructor(public payload: WishlistEntry) {
    super(WISHLIST_REMOVE_ENTRY, payload.productCode);
  }
}

export class RemoveWishlistEntryFail extends StateUtils.EntityFailAction {
  readonly type = REMOVE_WISHLIST_ENTRY_FAIL;

  constructor(
    public payload: WishlistEntry,
    error: unknown,
  ) {
    super(WISHLIST_REMOVE_ENTRY, payload.productCode, error);
  }
}

export type RemoveWishlistEntryActions = RemoveWishlistEntry | RemoveWishlistEntrySuccess | RemoveWishlistEntryFail;
